import React, { useState, useEffect } from 'react';
import LazyImage from './LazyImage';
import './ImageSlider.css';

const ImageSlider = ({ images, autoPlay = true, interval = 5000 }) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    if (!autoPlay || images.length <= 1) return;

    const timer = setInterval(() => {
      setCurrentIndex((prevIndex) => 
        prevIndex === images.length - 1 ? 0 : prevIndex + 1
      );
    }, interval);

    return () => clearInterval(timer);
  }, [autoPlay, interval, images.length]);


  if (!images || images.length === 0) {
    return null;
  }

  return (
    <div className="image-slider">
      <div className="slider-container">
        {images.map((image, index) => (
          <div
            key={index}
            className={`slide ${index === currentIndex ? 'active' : ''}`}
          >
            <LazyImage
              src={image.src}
              alt={image.alt}
              className="slide-image"
            />
            {image.overlay && (
              <div className="slide-overlay" style={image.overlay}></div>
            )}
          </div>
        ))}
        
        
      </div>
    </div>
  );
};

export default ImageSlider;
